// extracted by mini-css-extract-plugin
export default {"next_s":"Arrows_next_s__vnxBB","prev_s":"Arrows_prev_s__t4P91"};